import React from 'react';
import { PortfolioTrackerCompanySummaryProps } from '../PortfolioTrackerCompanySummary';
import { PortfolioCompanyInsights } from './PortfolioCompanyInsights';
import { NotShared } from '../NotShared';
import { isViewShared } from '@utils/dataShare';
import { DataShareScopeView } from '@g17eco/types/surveyDataScope';
import { InitiativeCompany } from '@g17eco/types/initiativeSurvey';
import { Portfolio } from '@g17eco/types/portfolio';
import { PortfolioTrackerCompanyHeader } from '../PortfolioTrackerCompanyHeader';
import { useGetDefaultDashboardsQuery } from '@api/portfolio-insight-dashboards';
import { BlockingLoader } from '@g17eco/atoms/loader';
import { generateUrl } from '@routes/util';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '@constants/routes';

interface PortfolioCompanyInsightsWrapperProps {
  company: InitiativeCompany;
  portfolio: Portfolio;
  summaryPage?: string;
  ptCompanyHeaderProps: PortfolioTrackerCompanySummaryProps;
  dashboardId?: string;
}

export const PortfolioCompanyInsightsWrapper: React.FC<PortfolioCompanyInsightsWrapperProps> = ({
  company,
  portfolio,
  summaryPage,
  ptCompanyHeaderProps,
  dashboardId,
}) => {
  const { data, isFetching } = useGetDefaultDashboardsQuery({ portfolioId: portfolio._id });
  const history = useHistory();

  if (isFetching) {
    return <BlockingLoader />;
  }

  if (data?.[0]?._id && !dashboardId && !summaryPage) {
    history.push(
      generateUrl(ROUTES.PORTFOLIO_TRACKER_COMPANY_DASHBOARD, {
        portfolioId: portfolio._id,
        companyId: company._id,
        dashboardId: data[0]._id,
      }),
    );
    return <BlockingLoader />;
  }

  if (isViewShared(company, DataShareScopeView.Insights)) {
    return (
      <>
        <PortfolioTrackerCompanyHeader hasSidebar {...ptCompanyHeaderProps} />
        <div className='-mt-5'>
          <PortfolioCompanyInsights
            // Remount per company so the previous company's survey isn't requested with the new company id
            key={company._id}
            className='insights-dashboard'
            portfolio={portfolio}
            company={company}
            summaryPage={summaryPage}
            dashboards={data}
            dashboardId={dashboardId}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <PortfolioTrackerCompanyHeader {...ptCompanyHeaderProps} />
      <NotShared title='Insights'>Company has not shared Insights</NotShared>
    </>
  );
};
